import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col, Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Products } from '../../constants/products';

export const CreateActivityModal = ({show, hide, data, updated, submitted}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Activity</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>

                    {formTextField('Activity Name', 'Pascal Case, e.g., MyActivityName', updated, data.activityNameValidation)}
                    {formTextField('Instructional Name', 'The instructional name of the activity.', updated, data.instructionalNameValidation)}
                    {formTextField('Description', 'Information about the new activity', updated, data.descriptionValidation)}
                    {formOptionsField('Product', Products, updated, data.productValidation)}
                    {formCheckbox('Scores', updated)}
                    {renderButton(data.isRequesting, data.isFormValid)}

                </Form>
            </Modal.Body>
        </Modal>
    );
};

const renderButton = (isRequesting, isFormValid) =>
{
    if(isRequesting)
    {
        return( 
            <Button type="submit" style={{backgroundColor:'blue', color: 'white'}} block disabled={isRequesting}>Creating...</Button>
        );
    }
    else
    {
        return(
            <Button type="submit" bsStyle="success" block disabled={isFormValid && !isRequesting}>Create</Button>            
        )
    }
}

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOptionsField = (label,  options, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl componentClass='select' name={label} onChange={onChange} defaultValue=''>
                    <option value='' disabled/>
                    {Object.entries(options).map(formOption)}
                </FormControl>
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOption = kvp => {
    return (<option key={kvp[0]} value={kvp[1]}>{kvp[1]}</option>);
};

const formCheckbox = (label, onChange) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <Checkbox name={label} onChange={onChange}></Checkbox>
            </Col>
        </FormGroup>   
    );
}

CreateActivityModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/createActivityModal/CreateActivityModal.js